module.exports = __webpack_public_path__ + "static/img/tree.38f8a5e1.png";